/**
 * Community-program CTA + /community/accept page localized copy.
 * Re-export shim over /locales/{en,ht,fr,es}.json (community_cta key).
 * See /locales/README.md.
 *
 * Consumers:
 *  - frontend/components/CommunityCta.js reads .labels[state] to
 *    localize the CTA button label the backend returns.
 *  - frontend/pages/community/accept.js reads .accept_page.* for the
 *    accept-flow confirmation page copy.
 */
import en from '../locales-shared/en.json'
import ht from '../locales-shared/ht.json'
import fr from '../locales-shared/fr.json'
import es from '../locales-shared/es.json'
import ptBR from '../locales-shared/pt-BR.json'
import zhHans from '../locales-shared/zh-Hans.json'

const COPY = {
  en: en.community_cta,
  ht: ht.community_cta,
  fr: fr.community_cta,
  es: es.community_cta,
  'pt-BR': ptBR.community_cta,
  'zh-Hans': zhHans.community_cta,
}

export default COPY
